// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"2589":"209e1c9c","4964":"467b4c86","8954":"81b2b850","9103":"b9ea4917"}[chunkId] + ".css";
};